import { type InputHTMLAttributes, type ReactNode } from 'react';
import { cx } from './utils.js';

export type SwitchProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> & {
  label?: ReactNode;
  description?: ReactNode;
};

export function Switch({ label, description, className, id, disabled, ...rest }: SwitchProps) {
  return (
    <label
      htmlFor={id}
      className={cx(
        'inline-flex cursor-pointer items-start gap-3',
        disabled && 'cursor-not-allowed opacity-60',
        className,
      )}
      data-ui="switch"
    >
      <span className="relative mt-0.5 inline-flex shrink-0">
        <input {...rest} id={id} type="checkbox" disabled={disabled} className="peer sr-only" />
        <span className="h-5 w-9 rounded-full bg-slate-200 transition peer-checked:bg-[color:var(--admin-accent,#2563EB)] peer-focus-visible:ring-2 peer-focus-visible:ring-[color:var(--admin-accent,#2563EB)] peer-focus-visible:ring-offset-2" />
        <span className="pointer-events-none absolute top-0.5 left-0.5 size-4 rounded-full bg-white dark:bg-slate-900 shadow transition peer-checked:translate-x-4" />
      </span>
      {label || description ? (
        <span className="min-w-0 text-sm">
          {label ? <span className="block font-medium text-slate-800 dark:text-slate-200">{label}</span> : null}
          {description ? <span className="mt-0.5 block text-xs text-slate-500 dark:text-slate-400 dark:text-slate-500">{description}</span> : null}
        </span>
      ) : null}
    </label>
  );
}
